import { gql, useQuery } from "@apollo/client";
import useRetryOn429 from "hooks/useRetryOn429";
import { Select } from "../base/Form";

const FETCH_ODOO_WAREHOUSES = gql`
  query FETCH_ODOO_WAREHOUSES($company: String!, $refresh: Boolean) {
    odooWarehouses(company: $company, refresh: $refresh)
  }
`;

const OdooWarehouseSelector = ({
  company = "AB",
  value,
  onSelect,
  filterFunction,
  ...rest
}) => {
  const { loading, error, data, refetch } = useQuery(FETCH_ODOO_WAREHOUSES, {
    variables: { company },
    skip: !company,
  });
  const { isAutoRetrying } = useRetryOn429({ error, refetch });

  const odooWarehouses = data
    ? JSON.parse(data.odooWarehouses).filter((i) =>
        filterFunction ? filterFunction(i) : i,
      )
    : [];

  return (
    <Select
      value={value || "0"}
      onChange={(e) => onSelect(e.target.value)}
      {...rest}
    >
      {loading || isAutoRetrying ? (
        <option value="0" disabled>
          loading...
        </option>
      ) : error ? (
        <option value="0" disabled>
          {error.message}
        </option>
      ) : (
        <>
          <option value="0" disabled>
            --- Select ---
          </option>
          {odooWarehouses.map((i, index) => (
            <option key={index} value={i.id}>
              {i.name}
            </option>
          ))}
        </>
      )}
    </Select>
  );
};

export default OdooWarehouseSelector;
